<!-- slider -->
<section class="about-us-slider swiper-container p-relative">
  <div class="swiper-wrapper">
    <div class="swiper-slide slide-item">
      <img
        src="assets/img/banner/01-Banner-Nail.png"
        class="img-fluid full-width"
        alt="Banner"
      />
      <div class="transform-center">
        <div class="container">
          <div class="row justify-content-start">
            <div class="col-lg-7 align-self-center">
              <div class="right-side-content">
                <h1 class="text-custom-white fw-600">
                  Perfect your style with stunning nails
                </h1>
                <h3 class="text-custom-white fw-400">
                  Experience professional, clean, and long-lasting nail care
                </h3>

                <a routerLink="/restaurant" class="btn-second btn-submit"
                  >Learn More.</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay overlay-bg"></div>
    </div>
    <div class="swiper-slide slide-item">
      <img
        src="assets/img/banner/02-Banner-Spa.png"
        class="img-fluid full-width"
        alt="Banner"
      />
      <div class="transform-center">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 align-self-center">
              <div class="right-side-content text-center">
                <h1 class="text-custom-white fw-600">
                  Relax, refresh, and renew your body
                </h1>
                <h3 class="text-custom-white fw-400">
                  Premium spa treatments designed to restore your energy
                </h3>

                <a routerLink="/restaurant" class="btn-second btn-submit"
                  >Learn More.</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay overlay-bg"></div>
    </div>
    <div class="swiper-slide slide-item">
      <img
        src="assets/img/banner/03-Banner-Waxing.png"
        class="img-fluid full-width"
        alt="Banner"
      />
      <div class="transform-center">
        <div class="container">
          <div class="row justify-content-end">
            <div class="col-lg-7 align-self-center">
              <div class="right-side-content text-right">
                <h1 class="text-custom-white fw-600">
                  Smooth skin that boosts your confidence
                </h1>
                <h3 class="text-custom-white fw-400">
                  Gentle and hygienic waxing services for every skin type
                </h3>

                <a routerLink="/restaurant" class="btn-second btn-submit"
                  >Learn More.</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay overlay-bg"></div>
    </div>
    <div class="swiper-slide slide-item">
      <img
        src="assets/img/banner/04-Banner-Pets.png"
        class="img-fluid full-width"
        alt="Banner"
      />
      <div class="transform-center">
        <div class="container">
          <div class="row justify-content-end">
            <div class="col-lg-7 align-self-center">
              <div class="right-side-content text-right">
                <h1 class="text-custom-white fw-600">
                  Pamper your pets with loving care
                </h1>
                <h3 class="text-custom-white fw-400">
                  Professional grooming and spa services for your furry friend
                </h3>

                <a routerLink="/restaurant" class="btn-second btn-submit"
                  >Learn More.</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay overlay-bg"></div>
    </div>
  </div>
  <!-- Add Arrows -->
  <div class="swiper-button-next"></div>
  <div class="swiper-button-prev"></div>
</section>
<!-- slider -->
